// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MVuY","title":"Header_title__9hNRc","side":"Header_side__2zlmF"};